import React from 'react'
import PropTypes from 'prop-types'
import { animated } from 'react-spring'
import { useFade } from './Fade.hooks'

const Fade = React.forwardRef(function Fade(props, ref) {
	const [elementProps] = useFade(props)

	return <animated.div ref={ref} {...elementProps} />
})

Fade.propTypes = {
	in: PropTypes.bool,
	onEnter: PropTypes.func,
	onExited: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
}

export default Fade
